import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const AllotmentInfo = ({
    reasonType,
    showAllotmentNextYear,
    nextYearAllotment,
    yearOfRequest
}) => {
    return (
        <VStack spacing="Zero_25">
            <Text
                variant="Descriptive_1_1"
                color="Gray_2"
            >
                Remaining / Total
            </Text>
            <HStack spacing="Zero_25">
                <Text variant="Body_2_1" color="Black">
                    {reasonType?.daysRemaining} /{" "}
                    {reasonType?.allotment ?? 0}
                    {" (" + yearOfRequest + ")"}
                </Text>
                {showAllotmentNextYear &&
                    <Text variant="Body_2_1" color="Black">
                        {" ; "}
                        {nextYearAllotment?.daysRemaining} /{" "}
                        {nextYearAllotment?.allotment ?? 0}
                        {" (" + (yearOfRequest + 1) + ")"}
                    </Text>}
            </HStack>
        </VStack>
    );
};

AllotmentInfo.propTypes = {
    reasonType: PropTypes.object,
    showAllotmentNextYear: PropTypes.bool,
    nextYearAllotment: PropTypes.object,
    yearOfRequest: PropTypes.number
};

export default AllotmentInfo;
